import { render } from "./ConnectionsSettings.vue?vue&type=template&id=285be752"
import script from "./ConnectionsSettings.vue?vue&type=script&lang=js"
export * from "./ConnectionsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/ConnectionsSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "285be752"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('285be752', __exports__)) {
    api.reload('285be752', __exports__)
  }
  
  module.hot.accept("./ConnectionsSettings.vue?vue&type=template&id=285be752", () => {
    api.rerender('285be752', render)
  })

}


export default __exports__